const DEFAULT_VIGLINK_KEY =
	process.env.NEXT_PUBLIC_VIGLINK_KEY || 'aadacb5240dc74e48b996456c0f60b88';
const DEFAULT_VIGLINK_SUB_ID = process.env.NEXT_PUBLIC_VIGLINK_SUB_ID || '';
const REDIRECT_BASE_URL = 'https://redirect.viglink.com/';

const ensureProtocol = (url) => {
	if (!url) {
		return '';
	}

	const trimmedUrl = url.trim();
	if (!trimmedUrl) {
		return '';
	}

	return /^https?:\/\//i.test(trimmedUrl)
		? trimmedUrl
		: `https://${trimmedUrl.replace(/^\/+/, '')}`;
};

const getVigLinkUrl = (url, options = {}) => {
	const normalizedUrl = ensureProtocol(url);
	if (!normalizedUrl) {
		return '';
	}

	const key = options.key || DEFAULT_VIGLINK_KEY;
	const subId =
		options.subId === undefined ? DEFAULT_VIGLINK_SUB_ID : options.subId;

	if (!key) {
		return normalizedUrl;
	}

	const params = new URLSearchParams({
		key,
		u: normalizedUrl,
	});

	if (subId) {
		params.set('subId', subId);
	}

	return `${REDIRECT_BASE_URL}?${params.toString()}`;
};

export { ensureProtocol };
export default getVigLinkUrl;
